export default __webpack_public_path__ + "static/media/tab-remove.50447fd8.svg";